"use client";
import React from "react";
import { FaSearch } from "react-icons/fa";
import Image from "next/image";
import Link from "next/link";
import useSearchCourses from "@/hook/useSearchCourses";

export default function SearchBarMobile() {
  const {
    searchText,
    setSearchText,
    suggestions,
    setSuggestions,
    showDropdown,
    setShowDropdown,
    wrapperRef,
    handleInputChange,
  } = useSearchCourses();

  return (
    <div className="by-using-text-search relative" ref={wrapperRef}>
      <input
        type="text"
        placeholder="সার্চ করো"
        className="text-intup"
        value={searchText}
        onChange={handleInputChange}
      />
      <button type="submit" className="submit-btn">
        <FaSearch className="search-icon" />
      </button>

      {showDropdown && suggestions.length > 0 && (
        <div className="absolute z-50 w-full bg-white [.dark_&]:bg-d-oxford-blue border border-gray-200 [.dark_&]:border-d-shadow-blue mt-2 rounded shadow top-8 right-0">
          {suggestions.map((course, index) => (
            <Link
              href={`/course/${course.slug}`}
              key={index}
              className="flex items-center p-2 hover:bg-gray-100"
              onClick={() => {
                setSearchText("");
                setSuggestions([]);
                setShowDropdown(false);
              }}
            >
              <Image
                src={course.thumbnail_url}
                alt={course.title}
                width={40}
                height={40}
                className="rounded object-cover mr-2"
              />
              <span className="text-sm text-primary-text-3 [.dark_&]:text-d-white">{course.title}</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
